/**
 * Utility functions for category operations
 */

/**
 * Converts a category name to its slug format
 * This matches the slugify pattern used in the backend migrations
 * 
 * @param {string} name - Category name
 * @returns {string} - Category slug
 */
export const getCategorySlug = (name) => {
  if (!name) return '';
  
  return name
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove non-word characters
    .replace(/[\s_-]+/g, '-') // Collapse spaces/underscores
    .replace(/^-+|-+$/g, ''); // Trim - from start/end
};

/**
 * Checks if a product belongs to a specific category by slug
 * 
 * @param {Object} product - Product object
 * @param {string} categorySlug - Category slug to check against
 * @returns {boolean} - Whether the product belongs to the category
 */
export const isProductInCategory = (product, categorySlug) => {
  if (!product || !categorySlug) return false;
  
  // Check main category
  if (product.CatName && getCategorySlug(product.CatName) === categorySlug) {
    return true;
  }
  
  // Check super category
  if (product.SuperCatName && getCategorySlug(product.SuperCatName) === categorySlug) {
    return true;
  }
  
  // Check sub category
  if (product.SubCatName && getCategorySlug(product.SubCatName) === categorySlug) {
    return true;
  }
  
  return false;
};

/**
 * Category slug constants for easy reference
 */
export const CATEGORY_SLUGS = {
  LAMINATE: 'laminate',
  ENGINEERED_WOOD: 'engineered-wood',
  WOOD: 'wood',
  VINYL: 'vinyl',
  TILES: 'tiles',
  BASEBOARDS_TRIMS: 'baseboards-trims',
  BASEBOARDS: 'baseboards',
  TRIMS: 'trims',
  SOLID_HARDWOOD: 'solid-hardwood',
  SOLID_WOOD: 'solid-wood'
};

const categoryUtils = {
  getCategorySlug,
  isProductInCategory,
  CATEGORY_SLUGS
};

export default categoryUtils;
